module.exports = __webpack_public_path__ + "img/grid-45.18acea8b.svg";